import React, { FunctionComponent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GameProvider from "../game-provider";
import { GameInfoNav, Spinner } from "../components";
import { NotFoundView } from "./not-found";
import ApiService from "../services/api-services";
import { GameCodes } from "../type";
import {
  useTranslator,
  useTranslationReducer,
} from "../context/TranslationContext";

export const RuleView: FunctionComponent = () => {
  const { gameCode: rawGameCode = "" } = useParams();
  const [gameCode, setGameCode] = useState<GameCodes>(GameCodes.Unknown);
  const [rule, setRule] = useState<Record<string, unknown>>();
  const [notFound, setNotFound] = useState(false);
  const translationReducer = useTranslationReducer();
  const translator = useTranslator();

  useEffect(() => {
    const gameCode = GameProvider.convertGameCode(
      rawGameCode || GameCodes.Unknown
    );
    setGameCode(gameCode);
    if (gameCode !== GameCodes.Unknown)
      ApiService.getRule(gameCode)
        .then((res) => {
          if (res.ok && res.data) {
            setRule(res.data);
          } else {
            setNotFound(true);
          }
        })
        .catch((e) => {
          console.error(e);
          setNotFound(true);
        });
  }, [rawGameCode]);

  useEffect(() => {
    translationReducer();
  }, []);

  if (!gameCode || gameCode === GameCodes.Unknown || notFound)
    return <NotFoundView />;

  if (!rule) return <Spinner />;
  const title = translator.getGameName(gameCode);
  const ruleComponent = GameProvider.getGameRuleView(gameCode);

  document.title = `${title} - Rules`;
  return (
    <>
      <GameInfoNav gameCode={rawGameCode} />
      <div className="px-3 pt-2">
        <div>
          <h3>{title}</h3>
        </div>
        <hr />
        <div className="card">
          <div className="card-header">Rules</div>
          <div className={`card-body ${gameCode}`}>
            {React.createElement(ruleComponent, {
              key: "rule-component",
              data: rule,
            })}
          </div>
        </div>
      </div>
    </>
  );
};
